import React, { useState, useEffect } from "react";
import "./MainScreen.css";
import FeedbackModal from "./FeedbackModal.js";
import ChatList from "./ChatList.js";

import { sendAsk, sendNewAsk, sendFeedback, getOneTimeToken } from "../functions/be-sage.js";

function MainScreen() {
 const [askText, setAskText] = useState("");
 const [responseText, setResponseText] = useState("");
 const [loading, setLoading] = useState(false);
 const [requestID, setReqID] = useState("");
 const [showModal, setShowModal] = useState(false);
 const [comment, setComment] = useState("");
 const [config, setConfig] = useState(null);
 const [CLog, setCLog] = useState([]);
 const [category, setCategory] = useState([]);

 useEffect(() => {
  fetch("./config.json") // ビルド後のディレクトリから取得
   .then((response) => response.json())
   .then((data) => setConfig(data))
   .catch((error) => console.error("設定ファイルの読み込みエラー:", error));
 }, []);

 useEffect(() => {
  setAskText(config?config.DefaultQ:"");
  document.title = config?config.SiteTitle:"";
  const options = config?.Categories
   ? config.Categories.split(",").map((item) => item.trim()).filter(Boolean)
   : [];
  setCategory(options);
 }, [config]);

 // 回答生成リクエスト
 const handleSend = async () => {
  setLoading(true);
  setResponseText("");

  const current_chatid = CLog.length > 0 ? CLog[0].chatid : "";

  // 質問と「生成中」メッセージを先に表示
  const newConv = {
    askText: askText,
    resText: "回答生成中...",
    contentList: [],
    reqid: "",
    chatid: current_chatid
  };
  setCLog(prevCLog => [newConv, ...prevCLog]);

  const { responseText, documents, reqid, chatid } = await sendNewAsk(config, askText, category, current_chatid);

  // APIの応答が来たら、該当のチャットを更新
  setCLog(prevCLog => {
    const updatedCLog = [...prevCLog];
    const targetLog = updatedCLog[0]; // 先頭が更新対象
    targetLog.resText = responseText;
    targetLog.contentList = documents; // APIからのsourcesをcontentListとして保存
    targetLog.reqid = reqid;
    targetLog.chatid = chatid || ""; // chatidがundefinedの場合でも空文字をセット
    return updatedCLog;
  });

  setLoading(false);
 };

 // フィードバック送信
 const feedbackSend = async (rating, userComment = "") => {
  console.log(`送信: requestID=${requestID}, rating=${rating}, comment=${userComment}`);
  await sendFeedback(requestID, rating, userComment);
  alert("フィードバックを受け付けました。");
 };

 // バッドフィードバックのモーダルを開く
 const handleBadFeedbackClick = () => {
  setShowModal(true);
 };

 // モーダルの送信ボタン
 const handleSubmitFeedback = () => {
  feedbackSend(1, comment);
  setShowModal(false);
  setComment("");
 };

 // モーダルのキャンセルボタン
 const handleCloseModal = () => {
  setShowModal(false);
  setComment("");
 };

 const handleKeyDown = (e) => {
  if (e.ctrlKey && e.key === "Enter") {
   handleSend();
  }
 };

 const handleCategoryChange = (e) => {
  const { checked, value } = e.target;
  setCategory((prev) => {
   if (checked) {
    return prev.includes(value) ? prev : [...prev, value];
   }
   return prev.filter((item) => item !== value);
  });
 };

 const openViewer = async (cid, page, urs_viewer_url) => {
  if(urs_viewer_url){
    window.open(urs_viewer_url);
  }else{
    const { token } = await getOneTimeToken(config, cid, page);
    var viewer_url = config.ViewerHost + config.ViewerURL + '?token=' + token + "&pn=" + page;
    window.open(viewer_url);
  }
 }

 const categoryOptions = config?.Categories
  ? config.Categories.split(",").map((item) => item.trim()).filter(Boolean)
  : [];

 return (
  <div id="main">
      <header>
        <img className="AppLogo" src="AppLogo.png"></img>
        {config?config.SiteTitle:""}
      </header>

      <div id="main_contents">
        {config?.InfoLink && (
          <a className="InfoLink" href={config.InfoLink}>
            <label>このページについて</label><img src="info.png" />
          </a>
        )}

        <label htmlFor="ask">{config?config.AskTitle:""}:</label>
        <div id="category_list">
          回答範囲：
          {categoryOptions.map((item, index) => (
            <label key={`${item}-${index}`}>
              <input type="checkbox" name="category" value={item} 
                     checked={category.includes(item)} onChange={handleCategoryChange}/>
              <span>{item}</span>
            </label>
          ))}
        </div>
        <div id="ask_text">
          <textarea id="ask" name="story" rows="5" cols="33" value={askText} onChange={(e) => setAskText(e.target.value)} onKeyDown={handleKeyDown} disabled={loading} />
          <button id="btn_send" onClick={handleSend} disabled={loading}>{loading ? "送信中..." : "送信 (ctrl+Enter)"}</button>
        </div>

        <br />
        <label>ＡＩによって生成された回答:</label>

        {CLog.length > 0 && <ChatList CLog={CLog} openViewer={openViewer} config={config} />}
      </div>

      <div id="footer">
        <label>{config?config.copyright:""}</label>
      </div>

      {/* モーダルを表示 */}
      {showModal && (
        <FeedbackModal 
          comment={comment} 
          setComment={setComment} 
          onSubmit={handleSubmitFeedback} 
          onClose={handleCloseModal} 
        />
      )}
    </div>
 );
}

export default MainScreen;
